import routes from "./routes";
import CaptionPublishing from "./pages/CaptionPublishing/CaptionPublishing";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import useLanguageInitializer from "./hooks/useLanguageInitializer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  useLanguageInitializer();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/captionPublishing" element={<CaptionPublishing />} />
          <Route path="/captionpublishing" element={<CaptionPublishing />} />
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={route.component}
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
